import { useTranslation } from 'react-i18next'

import { CopyIcon, DotsThreeCircleVerticalIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnInstructionItemMenu = ({ data, onEdit, onDuplicate, onDelete }) => {
  const { t } = useTranslation()

  const menuItems = [
    {
      label: (
        <Styles.MenuItem>
          <PencilSimpleIcon />
          {t('Editar')}
        </Styles.MenuItem>
      ),
      onClick: () => onEdit(data),
    },
    {
      label: (
        <Styles.MenuItem>
          <CopyIcon />
          {t('Duplicar')}
        </Styles.MenuItem>
      ),
      onClick: () => onDuplicate(data),
    },
    {
      label: (
        <Styles.MenuItem>
          <TrashIcon />
          {t('Eliminar')}
        </Styles.MenuItem>
      ),
      onClick: () => onDelete(data),
    },
  ]

  return (
    <ButtonMenu
      stopPropagation
      menuItems={menuItems}
      renderButton={onClick => (
        <IconButton
          variant="text"
          onClick={onClick}
          icon={<DotsThreeCircleVerticalIcon size={24} weight="light" data-testid="return-instruction-item-menu" />}
        />
      )}
    />
  )
}

export default ReturnInstructionItemMenu
